import type { FaireProductEntity } from "../../entity_types/product";

export const p_btm7gekx2j: FaireProductEntity = {
  token: "p_btm7gekx2j",
  type: "product",
  name: "Cocktail and Cards /  A Lot Like Cocktails Card",
  brandToken: "b_kxk5df5zt5",
  brandName: "Noble Mick's - Craft Beverage Company",
  imageUrl:
    "https://cdn.faire.com/fastly/1f60f5b32316143f44e8716b1b6dba4735da080893042508f43bd5b666e1b6e5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5f1679c24a8677a97a1ab49913cf668381a36c650baf69f4e63e7bb35d8e309d.jpeg",
    "https://cdn.faire.com/fastly/2a042e9f38cc1945aca2ae22bab79b210fd2c780f49944e984552e8c64fbaca2.jpeg",
    "https://cdn.faire.com/fastly/48a0b6b4c54de9d0e5cf0b05f6de673eb852ab54919565a3acdcba9a1f38cfb5.jpeg",
  ],
  priceDollars: 4.25,
  description:
    'These premium greeting cards each contain a single serve craft cocktail.  You can now send a "Cocktail and a Card"! Instead of just sending your loved one a card they throw away after reading it...they have a cocktail too! \n\nOur cards are 5" x 7" printed on a premium matte card stock.  The cards have gold foil details and the envelopes are gold foil lined and self adhesive.  Each card comes on a dust jacket.\n\nNoble Mick\'s single serve craft cocktails are the perfect way to enjoy a craft cocktail anywhere, anytime.  At home or on the go there is no need to have all the ingredients to make your favorite cocktail.  \n\nNoble Mick\'s is NOT an infusion product these cocktails are ready to go when you are. Simply add H2O and Spirit, shake or stir with ice and enjoy. Never overly sweet or artificial tasting.  Seriously...our cocktails are delicious!\n\nAt Noble Mick\'s we use all natural fruit and vegetable powders, natural spices and flavors and pure cane sugar.  There is a real difference!',
  tags: [],
  msrpDollars: 8.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:09:07.891Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
